import React from 'react';

import { useIntl } from 'react-intl';

import { Row, Col, Form, Input, FormInstance, Select } from 'antd';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { ReportAreasFormValues } from '@/core/domain/reports/operational/Report.types';

interface Props {
  form?: FormInstance<ReportAreasFormValues>;
}

function AreaReportForm({ form }: Props) {
  const intl = useIntl();

  return (
    <Form form={form}>
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'areas.modal.report.form.description',
            })}
            name="description"
          >
            <Input />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem name="active" label="Status das Áreas">
            <Select
              allowClear
              options={[
                { label: 'Ativas', value: 'true' },
                { label: 'Inativas', value: 'false' },
              ]}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem
            name="subareaSituation"
            label="Status das Sub-áreas"
          >
            <Select
              allowClear
              options={[
                { label: 'Ativas', value: 'true' },
                { label: 'Inativas', value: 'false' },
              ]}
            />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default AreaReportForm;
